import React from 'react';
import { ConfigProvider, ThemeConfig } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './routes/AppRouter';
import './App.scss';
import Header from './components/Header/Header';
import Sidebar from './components/Sidebar/Sidebar';
import keycloak from './hooks/keycloak';
import KeycloakAuthHandler from './pages/login/KeycloakAuthHandler';
import { retrieveData } from './common/CommonExport';


const config: ThemeConfig = {
    token: { colorPrimary: '#D34A7C' },
    components: {
        Button: {
            colorPrimary: '#D23B7D',
            algorithm: true,
        },
        Input: {
            colorPrimary: '#eb2f96',
            algorithm: true,
        },
    },
};

const App: React.FC = () => {
    const isLoggedIn = retrieveData('isLoggedIn', true);

    return (
        <div className="App bg-[#F5F6FF] min-h-[100vh]">
            <ConfigProvider theme={config}>
                <BrowserRouter>
                    {keycloak.authenticated || isLoggedIn ? (
                        <>
                            <Header />
                            <Sidebar />
                            <KeycloakAuthHandler />
                            <AppRouter />
                        </>
                    ) : (
                        <>
                            <Header />
                            <Sidebar />
                            <AppRouter />
                        </>

                    )}
                </BrowserRouter>
            </ConfigProvider>
        </div>
    );
};

export default App;
